import React from 'react';
import styled from 'styled-components';

const Line = props => (
  <div className={props.className} onClick={props.onClick}>
    <div className="line">{props.children}</div>
  </div>
);

export default styled(Line)`
  .line {
    font-size: 1.1em;
    display: inline-block;
    position: relative;
    color: ${({ color }) => color};
    line-height: 2;
    transition: all 0.5s, color 1s;
    cursor: pointer;
  }
  .line:after {
    position: absolute;
    display: block;
    content: '';
    height: 2px;
    width: ${({ active }) => (active ? 0 : 100)}%;
    top: 50%;
    left: 0;
    background-color: gray;
    transition: 0.5s;
    background-color: ${({ color }) => color};
  }
`;



// WEBPACK FOOTER //
// ./src/Components/Aboutme/Line.js